import addressee from '../../defaultFieldDefinitions/Addressee';
import addressLine2 from '../../defaultFieldDefinitions/AddressLine2';
import companyName from '../../defaultFieldDefinitions/CompanyName';
import county from '../../defaultFieldDefinitions/County';
import nameNumber from '../../defaultFieldDefinitions/HouseNameOrNumber';
import postCode from '../../defaultFieldDefinitions/PostCode';
import streetName from '../../defaultFieldDefinitions/StreetName';
import townCity from '../../defaultFieldDefinitions/TownCity';
import FieldDefinitionDefault from '../DefaultCountry/FieldDefinitionDefault';

let FieldDefinitionAT = FieldDefinitionDefault;

if (window.start?.settings?.should_use_alternate_address_definition_at) {
  FieldDefinitionAT = [
    addressee,
    companyName,
    streetName,
    nameNumber,
    addressLine2,
    postCode,
    townCity,
    county,
  ];
}

export default FieldDefinitionAT;
